import { usePathname as useNextPathname } from 'next/navigation';
import { useLocation } from 'react-router';

import useReactRouterPageCheck from './useReactRouterPageCheck';

const usePathname = () => {
    const isReactRouter = useReactRouterPageCheck();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = isReactRouter ? useLocation() : null;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const nextPathname = !isReactRouter ? useNextPathname() : null;

    return (isReactRouter ? location?.pathname : nextPathname) || '';
};

export default usePathname;
